const LanguageOverlay = () => import(/* webpackChunkName: "Language" */ '@/assets/js/src/modules/lang/_views/LanguageOverlay.vue')

export default [
    {name: 'LanguageRoute', path: '/languages', meta: {uiType: 'Overlay',}, component: LanguageOverlay,},
]
